export const UberStatus = [
    {
        label: 'Select',
        value: '',
    },
    {
        label: 'Blue',
        value: 'Blue',
    },
    {
        label: 'Gold',
        value: 'Gold',
    },
    {
        label: 'Platinum',
        value: 'Platinum',
    },
    {
        label: 'Diamond',
        value: 'Diamond',
    },
    {
        label: 'Not Applicable',
        value: 'Not Applicable',
    },
];
